import React from 'react';
import StaffModule from '../components/staff/index';

const Staff = () => {
    return (
        <div className="outletConainer">
            <StaffModule />
        </div>
    );
};

export default Staff;
